import React from 'react';
import { Box, Typography, Divider, Paper, Button } from '@mui/material';
import eliaNomogram from '../../../../assets/images/eliaNomogram.svg';
import closeIcon from '../../../../assets/icons/closeIcon.svg';

export const ImageTooltip = ({ onClose }: { onClose: () => void }) => {
  return (
    <Box
      sx={{
        maxWidth: 400,
        borderRadius: '0.9375rem',
        position: 'absolute',
        top: '55%',
        left: '50%',
        transform: 'translate(-50%, -40%)',
        gap: '0.625rem',
        display: 'flex',
        flexDirection: 'column'
      }}
      component={Paper}
    >
      <Box sx={{ padding: '1rem', display: 'flex', flexDirection: 'column' }}>
        <Button
          onClick={onClose}
          sx={{ padding: 0, marginLeft: 'auto', minWidth: 0 }}
        >
          <img src={closeIcon} alt="Close" />
        </Button>
        <Typography
          align="center"
          sx={{
            fontFamily: 'Calibri',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '1.25rem',
            fontStyle: 'italic',
            color: '#002A3A',
            paddingTop: '0.9375rem'
          }}
        >
          General stress factor according to the Elia Nomogram. Values displayed
          in Abbott Nutrition app are approximate percentages.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src={eliaNomogram}
          alt="eliaNomogram"
          width={'370px'}
          height={'400px'}
        />
      </Box>
      <Box sx={{ padding: '1rem' }}>
        <Divider sx={{ width: '100%' }} />
        <Typography
          align="left"
          sx={{
            fontFamily: 'CalibriBoldItalic',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            color: '#004F71',
            padding: '0.625rem 0'
          }}
        >
          Reference:
        </Typography>
        <Typography
          align="left"
          sx={{
            fontFamily: 'Calibri',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '1.25rem',
            color: '#004F71'
          }}
        >
          Irish Nutrition and Dietetic Institute (2022) Nutrition Support
          Reference Guide.
        </Typography>
      </Box>
    </Box>
  );
};
